<template>
  <v-autocomplete
    outlined
    dense
    class="rounded-lg mt-1 mini-text field-edit"
    :label="keyValue"
    :clearable="true"
    :value="modelValue"
    :items="items"
    :hide-details="hideDetails"
    item-text="title"
    item-value="value"
    no-data-text="Нет результатов"
    @input="$emit('input',$event || null)"
    @click:clear="$emit('input', null)"
  />
</template>

<script>

export default {
  name: 'BooleanAutocomplete',
  props: {
    modelValue: { type: String | null, required: true },
    hideDetails: {type: Boolean, default: false},
    keyValue: { type: String, required: true },

  },

  data: () => ({ items: [{ title: 'Да', value: 'true' }, { title: 'Нет', value: 'false' }] }),

}

</script>
